/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Perform boolean operation</h4>

<p>Select two bodies and perform a boolean operation between them.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'>No shortcuts for this operation</li>
</ul>`;

export default function BooleanOpsTooltip() {
    return h('div', { innerHTML: body });
}
